import { add } from "./base";
class Handler {
    toString(value) {
        return typeof value == "string" ? "#" + value : "";
    }
    fromString(value) {
        return value ? "#" + value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        const result = unformatted.delete("#");
        return {
            ...(result.value ? result.prepend("#") : result),
            type: "text",
            length: [4, 7],
            pattern: /^#([0-9a-f]{3}|[0-9a-f]{6})$/i,
        };
    }
    unformat(formatted) {
        return formatted.delete("#");
    }
    allowed(symbol, state) {
        return (((symbol >= "0" && symbol <= "9") || (symbol >= "a" && symbol <= "f") || (symbol >= "A" && symbol <= "F")) &&
            state.value.length < 6);
    }
}
add("hex-color", () => new Handler());
//# sourceMappingURL=hex-color.js.map